export default "__VITE_ASSET__2892181b__"